import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { baseAbsenceRequestsEffects, baseAbsenceRequestsReducer, baseAbsenceRequestsSelectors } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature(
      baseAbsenceRequestsSelectors.ABSENCE_REQUESTS_FEATURE_KEY,
      baseAbsenceRequestsReducer.BaseAbsenceRequestsReducer
    ),
    EffectsModule.forFeature([baseAbsenceRequestsEffects.BaseAbsenceRequestsEffects]),
  ],
})
export class BaseAbsenceRequestsStoreModule {}
